(function ($) {
    $(document).ready(function () {
        childrenSlider();
    });

    $(document).on('blocks_logged_in', function (e, data) {
        $('.status_wrapper .current_status .value').text(data.status);
        $('.status_wrapper .current_status .value').addClass(data.status.toLowerCase());
        $('.status_wrapper .nr_nights .value').text(data.nights);
        $('.status_wrapper .current_points .value').text(data.nbPointsEarnLast12Months);
        childrenSlider($('.de_block_icons_list.block_logged_in'));
    });

    // Slick
    function childrenSlider($blockLoggedIn) {
        var wraps = $blockLoggedIn ?? $('.de_block_icons_list');

        if (wraps.length > 0) {
            wraps.each(function () {
                var current = $(this);
                if (!current.is(':visible')) {
                    return;
                }
                var wrap = current.find('.wrap');
                var isListLayout = current.hasClass('list');
                var slider = wrap.find('.icons .wrapper'),
                    slidesCount = slider.children().length,
                    hasCarousel = false;
                // refers to the carousel counter
                var status = wrap.find('.pagingInfo'),
                    pagerWrap = current.find('.pager_wrap'),
                    slidesToShow = 0;
                if (is_phone) {
                    slidesToShow = 1;
                    if (slidesCount > 1) {
                        hasCarousel = true;
                    }
                } else if (is_mobile) {
                    slidesToShow = 2;
                    if (slidesCount > 2) {
                        hasCarousel = true;
                    }
                } else {
                    slidesToShow = 3;
                    if (slidesCount > 3 && !isListLayout) {
                        hasCarousel = true;
                    }
                }
                wrap.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                    var i = ((currentSlide) ? (currentSlide / slidesToShow) : 0) + 1;
                    status.text(i + '/' + Math.ceil(slick.slideCount / slidesToShow));
                });


                if (hasCarousel) {
                    slider.slick({
                        rows: 0,
                        infinite: false,
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        prevArrow: accor_arrow_prev,
                        nextArrow: accor_arrow_next,
                        appendArrows: current.find('.pager_wrap'),
                        appendDots: current.find('.pager'),
                        centerMode: false,
                        centerPadding: '0px',
                        arrows: true,
                        dots: true,
                        variableWidth: false,
                        rtl: $('html').attr('dir') === 'rtl',
                        responsive: [
                            {
                                breakpoint: 1024,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 2,
                                    dots: true,
                                    appendDots: wrap.parent().find('.pager'),
                                }
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    dots: true,
                                    centerMode: true,
                                    centerPadding: '80px',
                                    appendDots: wrap.parent().find('.pager'),
                                }
                            },
                        ]
                    });
                } else {
                    pagerWrap.css('display', 'none');
                }


            })
        }
    }
}(jQuery));